import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useTranslation } from 'react-i18next';
import '@etchteam/diamond-ui/composition/FormGroup/FormGroup';
import '@etchteam/diamond-ui/control/Button/Button';
import '@etchteam/diamond-ui/canvas/Section/Section';
import '@/components/composition/Wrap/Wrap';
import '@/components/control/LocationInput/LocationInput';
import StartLayout from '@/pages/start.layout';
import LocationForm from './LocationForm';
/**
 * The user only has to enter a location to skip straight to the home recycling page.
 */
export default function HomeRecyclingStartPage() {
    const { t } = useTranslation();
    return (_jsx(StartLayout, { children: _jsx("locator-wrap", { children: _jsxs("diamond-section", { padding: "lg", children: [_jsx("h2", { children: t('start.homeRecycling.title') }), _jsx(LocationForm, { action: "/home-recycling" })] }) }) }));
}
